export default {
  download: {
    documentTitle: 'ORS trasa',
    download: 'Stažení',
    downloadFileName: 'Název souboru ke stažení',
    downloadFormat: 'Formát ke stažení',
    downloadRoute: 'Trasa stažení',
    preparingDownload: 'Příprava ke stažení ...',
    fileReady: 'Soubor je připraven',
    errorPreparingFile: 'Chyba přípravy souboru',
    fileTooBigToBeDownloaded: 'Soubor je příliš velký na to, aby mohl být stažen',
    standard: 'Standard'
  }
}
